export default __webpack_public_path__ + "static/media/jobsrun.2d8f3927.svg";